
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindTurbineLand as ObiWindTurbineLandElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-turbine-land.js';
 
 
 

 
 export const ObiWindTurbineLand = createComponent({
   react: React,
   tagName: 'obi-wind-turbine-land',
   elementClass: ObiWindTurbineLandElement,
   events: {
     
   }
  });
 
 